import { configService } from "../index";
import { BaseRequests } from "./BaseRequestsV2";
import { BaseRequestsInterface } from "./BaseRequestsV2";
import ExperienceAvailabilityForDay from '@/models/experience-availability';

export default {
  ...BaseRequests(
    () => configService.experienceAvailabilities,
    "experienceAvailability",
    () => new ExperienceAvailabilityForDay()
  )
} as BaseRequestsInterface;
